<template>
  <input class="auth-input" type="text" :placeholder="placeholder" :style="style" v-model="content" @input="sendOut" />
</template>

<script>
  import rem from '@edu-fe/rem'

  export default {
    name: 'AuthInput',
    data() {
      return {
        content: ''
      }
    },
    props: {
      placeholder: {
        type: String,
        default: '请输入相应信息',
      },
      type: {
        type: String,
        default: '',
      },
      width: {
        type: Number,
        default: 592 // 设计图宽度
      }
    },

    computed: {
      style () {
        return {
          width: rem.design2rem(this.width) + 'rem'
        }
      }
    },

    methods: {
      // send
      sendOut() {
        this.$emit('sendOut', this.content, this.type)
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../style/main";

  .auth-input {
    // width: use(592);
    height: use(90);
    background: #F7F7F7;
    border: use(2) solid #EFEFEF;
    border-radius: use(10);
    font-size: use(30);
    padding: use(30);
    box-sizing: border-box;
    color: #4A4A4A;
    letter-spacing: 0;
    display: block;
    margin: 0 auto;
    text-align: center;
    letter-spacing: use(1);
  }

  input::-webkit-input-placeholder {
    color: #9B9B9B;
  }

  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #9B9B9B;
  }

  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #9B9B9B;
  }

  input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #9B9B9B;
  }
</style>
